<template>
  <div>
    <el-form-item :label="'题目'+(index+1)" style="width:700px;">
      <Editor v-model='form.questionTitle' placeholder="请输入内容" />
    </el-form-item>

    <el-form-item label="选项" style="width:700px;">
      <el-radio-group v-model="form.radio[0]">
        <el-radio :label=1>对</el-radio>
        <el-radio :label=0>错</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="答案" style="width:700px;">
      <span v-if="form.radio[0] == 1">对</span>
      <span v-if='form.radio[0] == 0'>错</span>
    </el-form-item>

    <el-form-item label="解析" style="width:700px;">
        <Editor v-model='form.analysisContent' placeholder="请输入内容" />
    </el-form-item>
    <el-form-item label="" style="width:700px;border-bottom: 1px solid silver;">
      <el-button type="primary" @click="remove()" style="float:right">删除</el-button>
    </el-form-item>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "true-false",
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },
    title: {
      type: Object,
      default: function() {
        return {};
      }
    },
    iSubmit:{
      type: Boolean,
      default: false
    },
    sortOrder:{
      type:Number,
      default:0
    },
    childQuestion:{
      tyoe:Object,
      default:null
    },
    showChoice:{
      type:Boolean,
      default:false
    },
    index:{
      type:Number,
      default:0
    }
  },
  watch: {
    iSubmit:function(val){
      if(val)
      {
        this.$emit('done', {
          form:this.form
        });
      }
    },
    showChoice:function(val){
      if(val){
        this.form = this.childQuestion;
      }
      else{
        this.form ={
          questionTitle: "",
          radio: [-1], //单选题题答案
          radioData: ["", "", "", ""], //单选与多选的框
          correctAnswer: "",
          analysisContent: "",
          sortOrder:0
        }
      }
    }
  },
  data() {
    return {
      stuAnswer: [],
      form: {
        questionTitle: "",
        radio: [-1], //答案
        radioData: ["", "", "", ""], //单选与多选的框
        correctAnswer: "",
        analysisContent: "",
        sortOrder:0
      },
      checkRadio:''
    };
  },
  methods: {
    remove:function(){
      this.$emit('remove',this.index);
    }
  },
  created() {
    this.form = this.childQuestion;
    this.checkRadio = this.form.radio[0].toString();
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
